module.exports = __webpack_public_path__ + "3638d8e7af83511fe78abdeeb4d3fc5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./Res/img/live_video.jpg
// module id = 2580
// module chunks = 1